import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const isSearchOccurredSliceInitialState: boolean = false

const isSearchOccurredSlice = createSlice({
    name: 'isSearchOccurredSlice',
    initialState: isSearchOccurredSliceInitialState,
    reducers: {
        setIsSearchOccurred(_, action: PayloadAction<boolean>) {
            return action.payload;
        }
    }
});

export const isSearchOccurredSliceActions = isSearchOccurredSlice.actions;
export default isSearchOccurredSlice;